import { createContext } from 'react';

export const DangerContext = createContext({
  dangerMode: false,
  switchDangerMode: () => {},
});
